module.exports = __webpack_public_path__ + "static/media/check.c0982d2e.svg";